export const FLUID_COLOR_PALETTE = [
  "#A7E3F6",
  "#FF9EE2",
  "#FF9089",
  "#A1F2DE",
  "#E3DD80",
  "#94E9B8",
  "#FFDE6F",
  "#B4A5F5",
  "#C0EA9E",
  "#91E4E6",
  "#F9C479",
  "#B88E73",
  "#EB9B8C",
  "#FF9E6B",
  "#D19F93",
];

// Цвет жидкости/стадии — по порядковому номеру стадии, циклически по палитре.
export const colorForStageNumber = (stageNumber: number): string => {
  const index =
    ((stageNumber % FLUID_COLOR_PALETTE.length) + FLUID_COLOR_PALETTE.length) %
    FLUID_COLOR_PALETTE.length;
  return FLUID_COLOR_PALETTE[index];
};
